import QuickviewButton from './quickview-button';

var selectors = {
  trigger: '[data-trigger-quickview]',
  dataSectionId: 'data-section-id',
};
var sections = {};

class Quickview {
  constructor(section) {
    this.container = section.container;
    this.id = this.container.getAttribute(selectors.dataSectionId);

    this.init();
  }

  init() {
    sections[this.id] = [];
    const self = this;
    const buttons = this.container.querySelectorAll(selectors.trigger);

    if (buttons.length) {
      buttons.forEach((element) => {
        const buttonClass = new QuickviewButton(element, self.id);
        sections[self.id].push(buttonClass);
      });
    }
  }

  onUnload() {
    const buttonsArray = sections[this.id];
    for (let i = 0, len = buttonsArray.length; i < len; i++) {
      const button = buttonsArray[i];
      if (typeof button.unload === 'function') {
        button.unload();
      }
    }
  }
}

const quickviewSection = {
  onLoad() {
    this.section = new Quickview(this);
  },
  onUnload() {
    if (typeof this.section.unload === 'function') {
      this.section.unload();
    }
  },
};

export {quickviewSection, Quickview};
